import { get, post } from "../util/winterGameConfig";
import md5 from "js-md5";


// 我的战队页经销商点券数据
export const agentBonus = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/agentBonus", params);
};

// 我的战队页经销商奖励发放数据
export const cupReward = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/cupReward", params);
};

// 获取新老结盟当前服务中心的结盟状态
export const queryAllianceStatus = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryAllianceStatus", params);
};

// 保存新老结盟信息
export const saveCampusAlliance = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/saveCampusAlliance", params);
};

// 检查经销商信息
export const checkCampusAlliance = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/checkCampusAlliance", params);
};

// 判断是否有未读通知
export const checkAgentMessages = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/checkAgentMessages", params);
};
// 查询当前经销商通知
export const queryAgentMessages = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryAgentMessages", params);
};
// 通知已读
export const agentMessagesRead = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/agentMessagesRead", params);
};
// 松鼠杯-报名参与
export const addActivityCustom = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/addActivityCustom", params);
};
// 战队代理商首页
export const queryAgentIndexData = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryAgentIndexData", params);
};
// 获取服务中心数据
export const queryMatchCampus = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryMatchCampus", params);
};
// 生成二维码
export const qrCode = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/qrCode", params);
};
// 小组赛-日期搜索
export const agentGroupYesterdaySituation = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/agentGroupYesterdaySituation", params);
};
// 个人赛-日期搜索
export const agentPersonYesterdaySituation = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/agentPersonYesterdaySituation", params);
};
// 我的战队
export const agentMyTeam = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/agentMyTeam", params);
};
// 战队成员战绩
export const agentMyTeamMembers = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/agentMyTeamMembers", params);
};
// 战队成员战绩-成员详情
export const agentMyTeamMemberDetail = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/agentMyTeamMemberDetail", params);
};
// 小组赛排行榜-每轮
export const teamGroupSectionRank = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/teamGroupSectionRank", params);
};
// 小组赛排行榜-累计
export const teamGroupRank = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/teamGroupRank", params);
};
// 排行榜-团队赛-淘汰赛
export const teamKnockoutRank = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/teamKnockoutRank", params);
};

// 创建修改战队v2
export const matchTeamSignUpV2 = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/matchTeamSignUpV2", params);
};

// 添加战队成员
export const matchTeamAddMemberV2 = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/matchTeamAddMemberV2", params);
};

// 移除战队成员
export const matchTeamRemoveMemberV2 = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/matchTeamRemoveMemberV2", params);
};

// 查询战队成员
export const queryTeamMemberV2 = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryTeamMemberV2", params);
};

// 战队出战

export const teamMemberVar = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/teamMemberVar", params);
};
// 查询出战首页
export const queryTeamMemberMainVar = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryTeamMemberMainVar", params);
};

// 查询出战详情

export const queryTeamMemberDetailVar = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryTeamMemberDetailVar", params);
};
// 查询战队状态信息
export const queryMatchStatus = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryMatchStatus", params);
};
// 查询晚间PK场详情
export const queryPkDetails = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/eveningPkList", params);
};
// 判断当前赛季是否报名
export const checkAgentMatchSign = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/checkAgentMatchSign", params);
};
// 查询松果杯信息
export const queryMatchInfo = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryMatchInfo", params);
};

export const queryAgentAd = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet//tool/queryAgentAd", params);
};

// 今日战况

export const todaySituation = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/todaySituation", params);
};

// 昨日战绩

export const yesterdaySituation = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/yesterdaySituation", params);
};

// 昨日之星

export const yesterdayStar = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/yesterdayStar", params);
};

// 昨日之星V2

export const yesterdayStarV2 = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/yesterdayStarV2", params);
};

// 升级光荣榜
export const serviceCenterseGment = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/serviceCenterseGment", params);
};

// 战队赛程

export const teamSchedule = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/teamSchedule", params);
};
// 全部赛程

export const serviceCenterTeamSchedule = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/serviceCenterTeamSchedule", params);
};
// 战队战绩
export const teamRecord = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/teamRecord", params);
};

// 战队荣耀

export const eventHomePage = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/eventHomePage", params);
};
// 成员战绩
export const memberScore = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/memberScore", params);
};

// 全部学员

export const queryMembers = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/queryMembers", params);
};
// 查询历史赛季
export const queryHistoryCup = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/queryHistoryCup", params);
};

// 全部学员页查询历史赛季
export const queryHistoryCupV2 = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/queryHistoryCupV2", params);
};

// 全部学员页查询历史赛季
export const queryhistorycupv3 = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/squirrelcup/queryhistorycupv3", params);
};

// 查询历史赛季
export const teamScheduleDates = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/teamScheduleDates", params);
};

//代理商员工金币账户余额
export const queryAgentUserGoldCoinAccount = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/goldcoin/queryAgentUserGoldCoinAccount", params);
};

//训练场数据
export const getTrainingData = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/trainingData", params);
};

//查询战队日历
export const getTeamScheduleDates = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/summer/teamScheduleDates", params);
};


//我的战队页经销商奖励发放赛季列表
export const cupRewardSeason = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/cupRewardSeason", params);
};

//我的战队页经销商奖励发放数据V2
export const cupRewardV2 = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/cupRewardV2", params);
};

//判断是否显示奖励入口
export const checkRoles = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/cup2023v1/checkRoles", params);
};

//首页获取抽签信息页面
export const queryZoneInfo = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/queryZoneInfo", params);
};

//抽签页面
export const getAgentAllZone = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/getAgentAllZone", params);
};

//抽签接口
export const getAgentTeamZone = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/api/applet/match/getAgentTeamZone", params);
};

//通过赛季ID获取赛季信息
export const queryseasonconfigbyseasonid = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/squirrelcup/queryseasonconfigbyseasonid", params);
};


//通过赛季ID获取个人赛的前端配置首页
export const queryseasonpersonalhome = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/squirrelcup/queryseasonpersonalhome", params);
};

//通过赛季ID获取个人赛的前端配置升段光荣榜
export const queryseasonpersonaleaderbroad = (params) => {
  let date = parseInt(Date.now() / 1000);
  params.time = date;
  params.sign = md5("eWnIx3SCTRopyYi2" + date);
  return post("/squirrelcup/queryseasonpersonaleaderbroad", params);
};
